import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_AdvisorSettingsUpdated = new ThunderDispatcher('__onAdvisorSettingsUpdated');
//# sourceMappingURL=dispatcher.js.map